import { Link } from '@tanstack/react-router';
import type { ReactNode } from 'react';
import './public.css';

/** Head entries shared by every public page. The site is not indexable yet (getPublicSite.indexable). */
export function publicHead(title: string, description: string) {
  return {
    meta: [
      { title: `${title} · Eryce` },
      { name: 'description', content: description },
      { name: 'robots', content: 'noindex, nofollow' },
    ],
  };
}

export function PublicLayout({ children }: { children: ReactNode }) {
  return (
    <div className="pub">
      <a className="pub-skip" href="#pub-main">
        Skip to content
      </a>
      <header className="pub-header">
        <div className="pub-wrap pub-header__inner">
          <Link to="/" className="pub-brand" aria-label="Eryce home">
            <span className="pub-brand__mark" aria-hidden="true" />
            Eryce
          </Link>
          <nav className="pub-nav" aria-label="Public">
            <Link to="/explore" className="pub-nav__link" activeProps={{ 'aria-current': 'page' }}>
              Explore
            </Link>
            <Link to="/" hash="how" activeOptions={{ includeHash: true }} className="pub-nav__link pub-nav__link--wide">
              How it works
            </Link>
            <Link to="/" hash="inquiry" activeOptions={{ includeHash: true }} className="pub-nav__link pub-nav__cta">
              Describe your need
            </Link>
            <Link to="/login" className="pub-nav__signin">
              Sign in
            </Link>
          </nav>
        </div>
      </header>
      <main id="pub-main" className="pub-main" tabIndex={-1}>
        {children}
      </main>
      <footer className="pub-footer">
        <div className="pub-wrap pub-footer__inner">
          <p>
            Eryce curates powered sites and datacenter capacity and makes introductions on request.
            Listings are separately approved summaries; addresses, owners and terms stay private
            until both sides agree.
          </p>
          <p className="pub-footer__links">
            <Link to="/explore">Explore</Link>
            <Link to="/" hash="inquiry" activeOptions={{ includeHash: true }}>
              Contact
            </Link>
            <Link to="/login">Sign in</Link>
          </p>
        </div>
      </footer>
    </div>
  );
}
